import { ref, computed, onMounted, onUnmounted } from "vue";

export function useResponsivePopup(desktopWidth: number | string = 600, desktopHeight: number | string = 400) {
  const screenWidth = ref(window.innerWidth);
  const screenHeight = ref(window.innerHeight);

  function updateScreenSize() {
    screenWidth.value = window.innerWidth;
    screenHeight.value = window.innerHeight;
  }

  onMounted(() => {
    window.addEventListener("resize", updateScreenSize);
  });

  onUnmounted(() => {
    window.removeEventListener("resize", updateScreenSize);
  });

  const popupWidth = computed(() => {
    if (desktopWidth === "auto") {
      if (screenWidth.value < 1024) {
        return Math.floor(screenWidth.value * 0.9);
      }
      return "auto";
    }
    const widthNum = Number(desktopWidth);
    return screenWidth.value < widthNum ? Math.min(screenWidth.value * 0.9, widthNum) : widthNum;
  });

  const popupHeight = computed(() => {
    if (desktopHeight === "auto") {
      return "auto";
    }
    const heightNum = Number(desktopHeight);
    return screenHeight.value < heightNum ? Math.min(screenHeight.value * 0.8, heightNum) : heightNum;
  });

  const popupMaxWidth = computed(() => {
    return desktopWidth === "auto" ? 1370 : undefined;
  });

  const popupMaxHeight = computed(() => {
    return desktopHeight === "auto" ? Math.floor(screenHeight.value * 0.9) : undefined;
  });

  return {
    popupWidth,
    popupHeight,
    popupMaxWidth,
    popupMaxHeight,
  };
}
